import { styled as muiStyled } from '@mui/material/styles';
import { Skeleton } from '@mui/material';

export const CustomSkeleton = muiStyled(Skeleton)(() => ({
  background: 'transparent',
  transform: 'unset',
}));
